import axiosInstance from '../AxiosInstance';

export function getSupplier() {
    return axiosInstance.get(`suppliers/getSupplier`);
}